module.exports = __webpack_public_path__ + "static/temoignages-clients-6d1de7f6c38cdc4bcebfcc671c82d2a9.jpg";